'use strict';

var lib = require('./lib-75591456.js');
var index = require('./index-6f152094.js');

var textProperties = {
    h1: {
        container: 'h1',
        scale: index.FontScale.XXL,
        weight: index.FontWeight.HEAVIEST,
    },
    h2: {
        container: 'h2',
        scale: index.FontScale.XL,
        weight: index.FontWeight.HEAVIEST,
    },
    h3: {
        container: 'h3',
        scale: index.FontScale.L,
        weight: index.FontWeight.HEAVIEST,
    },
    h4: {
        container: 'h4',
        scale: index.FontScale.M,
        weight: index.FontWeight.HEAVIEST,
    },
    bodyLarge: {
        scale: index.FontScale.L,
    },
    bodyMedium: {
        scale: index.FontScale.M,
    },
    bodySmall: {
        scale: index.FontScale.S,
    },
    titleMedium: {
        scale: index.FontScale.M,
        weight: index.FontWeight.HEAVIER,
    },
    titleSmall: {
        scale: index.FontScale.S,
        weight: index.FontWeight.HEAVIER,
    },
    caption: {
        scale: index.FontScale.XS,
        emphasis: index.FontEmphasis.LOW,
    },
    captionStrong: {
        scale: index.FontScale.XS,
        emphasis: index.FontEmphasis.LOW,
        weight: index.FontWeight.HEAVIEST,
    },
};
var H1Text = lib.variant('H1Text', index.Text, textProperties.h1);
var H2Text = lib.variant('H2Text', index.Text, textProperties.h2);
var H3Text = lib.variant('H3Text', index.Text, textProperties.h3);
var H4Text = lib.variant('H4Text', index.Text, textProperties.h4);
var BodyLargeText = lib.variant('BodyLargeText', index.Text, textProperties.bodyLarge);
var BodyMediumText = lib.variant('BodyMediumText', index.Text, textProperties.bodyMedium);
var BodySmallText = lib.variant('BodySmallText', index.Text, textProperties.bodySmall);
var TitleMediumText = lib.variant('TitleMediumText', index.Text, textProperties.titleMedium);
var TitleSmallText = lib.variant('TitleSmallText', index.Text, textProperties.titleSmall);
var CaptionText = lib.variant('CaptionText', index.Text, textProperties.caption);
var CaptionStrongText = lib.variant('CaptionStrongText', index.Text, textProperties.captionStrong);

exports.BodyLargeText = BodyLargeText;
exports.BodyMediumText = BodyMediumText;
exports.BodySmallText = BodySmallText;
exports.CaptionStrongText = CaptionStrongText;
exports.CaptionText = CaptionText;
exports.H1Text = H1Text;
exports.H2Text = H2Text;
exports.H3Text = H3Text;
exports.H4Text = H4Text;
exports.TitleMediumText = TitleMediumText;
exports.TitleSmallText = TitleSmallText;
exports.textProperties = textProperties;
//# sourceMappingURL=variants-434e0406.js.map
